import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Typography, } from '@mui/material';
import React from 'react';
export var ExpandableSection = function (_a) {
    var title = _a.title, _b = _a.defaultExpanded, defaultExpanded = _b === void 0 ? true : _b, children = _a.children;
    return (_jsxs(Accordion, { defaultExpanded: defaultExpanded, elevation: 0, sx: {
            '&:before': { display: 'none' },
            '&:not(:last-child)': {
                borderBottom: 0,
            },
        }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, {}), sx: {
                    borderBottom: '1px solid #ccc',
                    '& .MuiAccordionSummary-content': { margin: 0 },
                }, children: _jsx(Typography, { variant: "subtitle1", fontWeight: "500", children: title }) }), _jsx(AccordionDetails, { sx: {
                    padding: '16px',
                    backgroundColor: '#fff',
                }, children: children })] }));
};
